export default {
  computed: {
    $currentUser () {
      if (!this.$store) return
      return {
        id: this.$store.state.userData.id,
        name: this.$store.state.userData.name,
        role: this.$store.state.userData.role,
        email: this.$store.state.userData.email
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/currentUser.js